import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

import type { QuoteAccessorial, AccessorialCharge } from '../domain/QuoteAccessorial'

export function formatAccessorialName(accesorial: QuoteAccessorial) {
  if (accesorial.stopType.length > 0) {
    const formattedStops = accesorial.stopType.map(stop => toCapitalizeFirstLetter(stop))
    return `${accesorial.name} (${formattedStops.toString()})`
  } else {
    return accesorial.name
  }
}

export function getAccessorialNames(quoteAccessorials?: Array<QuoteAccessorial>): {
  [key: string]: string
} {
  const accessorialNames: { [key: string]: string } = {}

  quoteAccessorials?.forEach(a => {
    accessorialNames[a.code] = formatAccessorialName(a)
  })

  return accessorialNames
}

export function formatAccessorialChargeKeyAndName(
  accessorialCharge: AccessorialCharge,
  accessorialNames: Record<string, string>
) {
  return {
    key: accessorialCharge.accessorial?.code,
    name: accessorialCharge.accessorial ? accessorialNames[accessorialCharge.accessorial.code] : '',
  }
}
